import { callPreparationItems, siteConfig } from "../../content/site";

export function CallPreparation() {
  return (
    <section
      className="call-preparation section section--compact"
      data-review-region="call-preparation"
      data-auth-signature="matsushima-phone-expectation"
      aria-labelledby="call-preparation-title"
    >
      <div className="section-shell call-preparation__layout">
        <div className="call-preparation__copy">
          <p className="section-kicker">すべてそろっていなくても大丈夫です</p>
          <h2 id="call-preparation-title">電話前に分かると早い情報</h2>
          <p>
            車種・年式・状態など、分かる範囲でお知らせください。
            車検証が手元にない場合も、まずは状況を伺います。
          </p>
          <p className="contact-note contact-note--boxed">
            {siteConfig.contactNote}
            <span aria-hidden="true">／</span>
            {siteConfig.closedDay}
          </p>
        </div>
        <ul className="preparation-list">
          {callPreparationItems.map((item, index) => (
            <li key={item}>
              <span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
